import type { CheckpointModel } from '@/types/models/CheckpointModel'
import type { AssociatedDeviceModel, DeviceModel } from '@/types/models/DeviceModel'
import type { EventModel } from '@/types/models/EventModel'
import type { Ref } from 'vue'

export enum EHubProvider {
    EVENT = 'event',
    CHECKPOINT = 'checkpoint',

    EVENT_DEVICES = 'eventDevices',
    DEVICES_HUB_CARD = 'devicesHubCard',
    IS_VIEWER_ONLY = 'isViewerOnly'
}

export type EventHubProvider = {
    event?: Ref<EventModel>
    handleChangeEvent?: (value?: Partial<EventModel>) => void
}

export type CheckpointHubProvider = {
    checkpoint?: CheckpointModel
    handleChangeCheckpoint?: (value?: Partial<CheckpointModel>) => void
}

export const defaultEventHubProvider: EventHubProvider = {}
export const defaultCheckpointHubProvider: CheckpointHubProvider = {}

export type EventDetailProvider = {
    devices?: Ref<(AssociatedDeviceModel | DeviceModel)[]>
    setDevices?: (devicesValue?: (AssociatedDeviceModel | Partial<DeviceModel>)[]) => void
}

export type DeviceHubCard = {
    hideAssociated: boolean
}
